import React from 'react';

import { Button, Row } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

export enum SelectorIconEnum {
  ADDRESS = 'address',
  ADD_CIRCLE = 'addCircle',
  CALENDAR = 'calendar',
  CLOCK = 'clock',
  HOTEL = 'hotel',
  HOME_ADDRESS = 'home_address',
  MORE = 'more',
  SUN = 'sun',
  TICKETS = 'tickets',
  TIMER = 'timer',
  TRANSPORT = 'transport',
}
interface ISelectorElement {
  action?: () => void;
  description?: string | JSX.Element;
  extra?: {
    label?: string;
    action: () => void;
  };
  header?: string;
  icon?: string;
  id: number | string;
  selected: boolean;
  title?: string | JSX.Element;
}
export default function CheckoutCard(props: ISelectorElement) {
  const {
    action = null,
    description = null,
    extra = null,
    icon = SelectorIconEnum.ADD_CIRCLE,
    id,
    header,
    title = null,
    selected = true,
  } = props;
  const cardClassName = classNames('checkout-card', {
    'checkout-card-selected': selected,
  });

  const handleClick: React.MouseEventHandler<HTMLDivElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!action) return;
    action();
  };

  const handleClickExtra: React.MouseEventHandler<HTMLDivElement> = (
    event
  ): void => {
    event.preventDefault();
    event.stopPropagation();
    if (!extra?.action) return;
    extra.action();
  };
  return (
    <div className={cardClassName} key={id} onClick={handleClick}>
      <div className="checkout-card__body">
        <div className="checkout-card__header">
          <div className={`icon icon--${icon}`} />
          <span className="checkout-card__header--text">{header}</span>
        </div>
        <div className="checkout-card__title fs-mask">{title}</div>
        <div className="checkout-card__description fs-mask">{description}</div>
      </div>
      {extra && (
        <div className="checkout-card__extra-action">
          <Button
            className="btn-ghost btn-ghost--minimalist accountPage__edit-button"
            onClick={handleClickExtra}
          >
            <Row align="middle">
              <span className="icon icon--edit accountPage__edit-button--icon" />
              <span className="accountPage__edit-button--label">
                {extra.label || <FormattedMessage id="button.edit" />}
              </span>
            </Row>
          </Button>
        </div>
      )}
    </div>
  );
}
